
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quick-purchase",
      function () {
        return require("private-next-pages/quick-purchase/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quick-purchase"])
      });
    }
  